module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('shop-select', {
    attrs: {
      "wxshops": ""
    },
    on: {
      "update": _vm.storeChange,
      "init": _vm.initChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addSalesperson
    }
  }, [_vm._v("添加管理员")])], 1)], 1), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "管理员",
      "name": "admin"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "核销员",
      "name": "verification_clerk"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.salespersonList,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属门店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getSalepersonShopList(scope.row.salespersonId, 'shop')
            }
          }
        }, [_vm._v("查看门店")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属店铺"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getSalepersonShopList(scope.row.salespersonId, 'distributor')
            }
          }
        }, [_vm._v("查看店铺")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.updateSalesperson(scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteSalesperson(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.DialogTitle,
      "visible": _vm.detailDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "管理门店"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1.5%"
    }
  }, [(_vm.rel_shops_ids) ? [_c('el-table', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.rel_shops_ids,
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "storeName",
      "label": "门店名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "type": "text",
            "icon": "el-icon-delete"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteRow(scope.$index, _vm.rel_shops_ids)
            }
          }
        })]
      }
    }], null, false, 2586270991)
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addShopAction
    }
  }, [_vm._v("添加适用门店")])], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "管理店铺"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1.5%"
    }
  }, [(_vm.rel_distributor_ids) ? [_c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.rel_distributor_ids
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "distributor_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteStoreRow(scope.$index, _vm.rel_distributor_ids)
            }
          }
        })]
      }
    }], null, false, 1179866699)
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addStoreAction
    }
  }, [_vm._v("添加适用店铺")])], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "193px"
    },
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "管理员姓名"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "193px"
    },
    attrs: {
      "placeholder": "请输入管理员姓名"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSalespersonAction
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "门店列表",
      "visible": _vm.relShop.relShopVisible,
      "before-close": _vm.handleCancel,
      "width": "70%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.relShop, "relShopVisible", $event)
      }
    }
  }, [
    [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      attrs: {
        "data": _vm.relShop.list
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "shop_id",
        "label": "id",
        "width": "60"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "store_name",
        "label": "门店名称",
        "width": "300"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "address",
        "label": "门店地址"
      }
    })], 1), _vm._v(" "), (_vm.relShop.total_count > _vm.relShop.params.pageSize) ? _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "layout": "prev, pager, next",
        "current-page": _vm.relShop.params.page,
        "total": _vm.relShop.total_count,
        "page-size": _vm.relShop.params.pageSize
      },
      on: {
        "current-change": _vm.handleRelShopCurrentChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.relShop.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.relShop.params, "page", $event)
        }
      }
    })], 1) : _vm._e()]
  ], 2), _vm._v(" "), _c('shopSelect', {
    attrs: {
      "store-visible": _vm.shopVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relShopIds,
      "get-status": _vm.setStatus
    },
    on: {
      "chooseStore": _vm.chooseShopAction,
      "closeStoreDialog": _vm.closeShopDialogAction
    }
  }), _vm._v(" "), _c('StoreSelect', {
    attrs: {
      "store-visible": _vm.storeVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relStores,
      "get-status": _vm.setStoreStatus
    },
    on: {
      "chooseStore": _vm.chooseStoreAction,
      "closeStoreDialog": _vm.closeStoreDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42aa5775", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42aa5775"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/shopstaff/salesperson/leaderlist.vue
// module id = 2670
// module chunks = 0